import { NgIf } from '@angular/common';
import { ChangeDetectorRef, Component, effect, Inject, inject, signal } from '@angular/core';
import { MatButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatSnackBar } from '@angular/material/snack-bar';

import { Store } from '@ngrx/store';

import { ExportType } from '@components/orders/saved-lists/order-list-view/order-list-view.component';

import { OrdersActions } from '../../../../@store/orders/orders.actions';
import { selectOrdersError } from '../../../../@store/orders/orders.selectors';

@Component({
  selector: 'ciwc-lists-export',
  imports: [
    MatButton,
    MatDialogActions,
    MatDialogContent,
    MatDialogTitle,
    MatProgressSpinner,
    MatIconModule,
    NgIf,
  ],
  templateUrl: './lists-export.component.html',
  styleUrl: './lists-export.component.scss',
})
export class ListsExportComponent {
  private readonly store = inject(Store);
  private readonly snackBar = inject(MatSnackBar);
  readonly error = this.store.selectSignal(selectOrdersError);
  readonly lastAction = this.store.selectSignal((state) => state.orders.lastAction);
  isExporting = signal(false);

  constructor(
    public dialogRef: MatDialogRef<ListsExportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { listId: number; listName: string; type: ExportType },
    private cdr: ChangeDetectorRef,
  ) {
    effect(() => {
      const action = this.lastAction();
      if (action === 'Export List Success' && this.isExporting()) {
        this.isExporting.set(false);
        this.dialogRef.close({
          success: true,
        });
      }
    });

    effect(() => {
      const error = this.error();
      const lastAction = this.lastAction();
      if (lastAction === 'Export List Failure' && error) {
        this.isExporting.set(false);
        this.snackBar.open(error, 'Close', {
          duration: 5000,
          horizontalPosition: 'end',
          verticalPosition: 'bottom',
        });
      }
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onConfirm(): void {
    this.isExporting.set(true);
    this.store.dispatch(
      OrdersActions.exportList({
        id: this.data.listId,
        exportFormat: this.data.type,
      }),
    );
  }
}
